import { useEffect, useState } from "react";

const mediaQuery = 'screen and (max-width: 1030px)';

export function useIsMobile(): boolean {
  const [ isMobile, setIsMobile ] = useState(window.matchMedia(mediaQuery).matches);

  useEffect(() => {
    const handler = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    window.matchMedia(mediaQuery).addEventListener('change', handler);
    return () => {
      window.matchMedia(mediaQuery).removeEventListener('change', handler);
    };
  }, []);

  return isMobile;
}
